import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { AudioAssetComponent } from '../audio-asset/audio-asset.component';
import { AudioClipFormControl } from '../audio-project.form';

@Component({
  selector: 'app-audio-clip',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AudioAssetComponent],
  templateUrl: './audio-clip.component.html',
  styleUrl: './audio-clip.component.scss',
})
export class AudioClipComponent {
  @Input() clip: FormGroup<AudioClipFormControl>;
}
